/* ==========================================================================
   Wicca Vibes — Celestial Gift Reveal popup behaviour

   Three jobs, all on top of Omnisend's own form (it still owns validation,
   submit, consent, triggers, analytics and A/B testing):

   1. MIRROR   — copy the chosen month's stone into the hidden `birthstone`
                 custom-property input, so Omnisend saves it alongside
                 `birthMonth` and the stone name is usable in email copy.
   2. GUARD    — Omnisend does not enforce `required` on custom-property radio
                 groups at runtime (verified on the live form: it advances to
                 Success with nothing selected). Block that and surface their
                 own "Please choose your sign" error element instead.
   3. REVEAL   — personalise the static Success screen: stone name in the
                 heading, the matching necklace photo, the meaning trio, and
                 point the CTA at the correct product variant.

   Everything is keyed off month names and field `name` attributes, never
   form/field IDs, so rebuilding the form does not break it. If Omnisend
   changes their markup this degrades to the plain form rather than erroring.
   ========================================================================== */
(function () {
  'use strict';

  var PRODUCT = '/products/mystical-birthstone-witches-knot-necklace';
  // The CTA must send people to items they can PAY for — the gift itself is free,
  // so the product page is a dead end at the highest-intent moment.
  var QUALIFYING = '/collections/birthstone-gift-qualifying';

  var STONES = {
    January:   { stone: 'Garnet',        variant: '51889999053121', trio: 'Passion • Strength • Vitality',
                 img: 'files/01_january_garnet_1080x1350_9396c55b-3541-454b-9e69-34fc61387a79.webp' },
    February:  { stone: 'Amethyst',      variant: '51889999020353', trio: 'Spiritual Insight • Calmness • Intuition',
                 img: 'files/02_february_amethyst_1080x1350_99e0c141-2a38-41e9-9d72-b6c0800ff5bb.jpg' },
    March:     { stone: 'Aquamarine',    variant: '51889999151425', trio: 'Courage • Serenity • Clear Communication',
                 img: 'files/03_march_aquamarine_1080x1350_ea1691dc-3499-4b8d-a77b-0c4f6bdaff12.jpg' },
    April:     { stone: 'Clear Crystal', variant: '51889998922049', trio: 'Purity • Clarity • Everlasting Love',
                 img: 'files/04_april_diamond_1080x1350_2629f897-f5ac-4717-b27c-d69ec27f0658.jpg' },
    May:       { stone: 'Emerald',       variant: '51889999184193', trio: 'Growth • Abundance • Harmony',
                 img: 'files/05_may_emerald_1080x1350_bc04ebf7-af99-4a54-9631-f4bc1e8511f3.jpg' },
    June:      { stone: 'Alexandrite',   variant: '51889999118657', trio: 'Balance • Transformation • Luck',
                 img: 'files/06_june_alexandrite_1080x1350_570f50cc-43c2-4426-9204-3c7edb4856c6.jpg' },
    July:      { stone: 'Ruby',          variant: '51889999085889', trio: 'Love • Courage • Vitality',
                 img: 'files/07_july_ruby_1080x1350_8662307a-5952-41f3-964b-98cb8e342bb4.jpg' },
    August:    { stone: 'Peridot',       variant: '51889998954817', trio: 'Renewal • Protection • Happiness',
                 img: 'files/08_august_peridot_1080x1350_c6f32708-f55f-4595-9abb-6bd20d5b73c6.jpg' },
    September: { stone: 'Sapphire',      variant: '51889999282497', trio: 'Wisdom • Truth • Spiritual Focus',
                 img: 'files/09_september_sapphire_1080x1350_12be1bd4-91ff-4803-8716-f154b2530102.jpg' },
    October:   { stone: 'Tourmaline',    variant: '51889999249729', trio: 'Creativity • Emotional Healing • Compassion',
                 img: 'files/10_october_tourmaline_1080x1350_cb32f0b2-5ca8-4d9e-86d5-97f4703bbaab.jpg' },
    November:  { stone: 'Citrine',       variant: '51889999216961', trio: 'Joy • Success • Prosperity',
                 img: 'files/11_november_citrine_1080x1350_7e9edf67-2f2e-4487-a206-d6df1f977936.jpg' },
    December:  { stone: 'Tanzanite',     variant: '51889998987585', trio: 'Vision • Truth • Inner Light',
                 img: 'files/12_december_blue_tanzanite_1080x1350_7caa0f64-008b-463c-a4f4-4803dae091b8.webp' }
  };

  var CDN = 'https://cdn.shopify.com/s/files/1/0035/0090/0461/';
  var STONE_NAMES = Object.keys(STONES).map(function (m) { return STONES[m].stone.toUpperCase(); });

  function root() { return document.getElementById('omnisend-forms-container'); }

  /* --- 0. LABELS: add stone name + properties into each tile --------------
     Done in JS rather than CSS ::after because two separately-styled lines
     need two elements, and ::before is already carrying the gem image.
     Must be idempotent — a MutationObserver re-runs this. */
  function labelText() {
    Object.keys(STONES).forEach(function (month) {
      var label = document.querySelector('label[for$="-' + month + '"]');
      if (!label || label.querySelector('.wv-stone')) return;

      var name = document.createElement('span');
      name.className = 'wv-stone';
      name.textContent = STONES[month].stone;

      var props = document.createElement('span');
      props.className = 'wv-props';
      props.textContent = STONES[month].trio;

      label.appendChild(name);
      label.appendChild(props);
    });
  }

  function chosenMonth() {
    var el = document.querySelector('input[name="custom_birthMonth"]:checked');
    return el ? el.value : (sessionStorage.getItem('wvBirthMonth') || '');
  }

  /* --- 1. MIRROR the stone into the hidden birthstone input --------------- */
  function mirror() {
    var input = document.querySelector('input[name="custom_birthstone"], textarea[name="custom_birthstone"]');
    if (!input) return;

    // hide the field wrapper, not just the input, so no empty box is left
    // Hide the OUTERMOST field container, not just the inner wrapper — the
    // outer one carries Omnisend's vertical spacing, so hiding only the inner
    // wrapper leaves a large empty gap where the field used to be.
    var wrap = input, node = input;
    while (node.parentElement) {
      node = node.parentElement;
      var cn = typeof node.className === 'string' ? node.className : '';
      if (/-field-(container|wrapper)/.test(cn)) wrap = node; else break;
    }
    // Every write here must be idempotent: a MutationObserver re-runs this, so
    // an unconditional write would retrigger itself and spin forever.
    if (!wrap.classList.contains('wv-hidden-field')) {
      wrap.classList.add('wv-hidden-field');
      // inline + !important: Omnisend's own rules outrank a plain utility class
      wrap.style.setProperty('display', 'none', 'important');
    }

    // the field is hidden on sight; the value only exists once a month is picked
    var month = chosenMonth();
    if (!month || !STONES[month]) return;
    sessionStorage.setItem('wvBirthMonth', month);
    // Persist across visits so the cart auto-add knows their stone on a return
    // trip, not just in this session. Wrapped: private mode can throw on write.
    try { localStorage.setItem('wvBirthMonth', month); } catch (e) {}

    // Warm the reveal image now — the Success screen renders it seconds later,
    // and without this the visitor sees an empty frame while it downloads.
    if (!mirror._warmed || mirror._warmed !== month) {
      mirror._warmed = month;
      var warm = new Image();
      warm.src = CDN + STONES[month].img + '?width=600';
    }

    if (input.value !== STONES[month].stone) {
      input.value = STONES[month].stone;
      // Omnisend may track its own state — fire what its listeners expect
      ['input', 'change', 'blur'].forEach(function (t) {
        input.dispatchEvent(new Event(t, { bubbles: true }));
      });
    }
  }

  /* --- 2. GUARD the step-2 submit ---------------------------------------- */
  function guard(e) {
    var btn = e.target.closest('button, [role="button"]');
    if (!btn) return;

    // only the button on the step holding the month radios
    var step = btn.closest('form, [class*="second-step-container"]');
    if (!step || !step.querySelector('input[name="custom_birthMonth"]')) return;

    if (document.querySelector('input[name="custom_birthMonth"]:checked')) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    // Reveal Omnisend's own error node for THIS field. Every field has its own
    // "-required" node, so a document-wide lookup grabs the wrong one. Don't use
    // closest('[class*="-field-container"]') either — the <label> class contains
    // that substring and holds no error node. Walk up to the first ancestor that
    // actually contains one (the field's <fieldset>).
    var err = null, node = document.querySelector('input[name="custom_birthMonth"]');
    while (node && !err) {
      node = node.parentElement;
      if (node) err = node.querySelector('[id$="-required"]');
    }
    if (err) {
      err.style.display = 'block';
      err.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  }

  /* Find the reveal wherever it lives: the Success screen, or a regular step
     that holds the reveal content (used when the reveal is moved to step 2 so
     an SMS field can be collected on it). Identified by content — a stone name
     or a trio line — and never the month picker. */
  function revealContainer() {
    var cands = document.querySelectorAll(
      '[class*="-sections-container"], [class*="-step-"][class*="-container"]'
    );
    for (var i = 0; i < cands.length; i++) {
      var c = cands[i];
      if (c.offsetParent === null) continue;
      if (c.querySelector('input[name="custom_birthMonth"]')) continue;
      var els = c.querySelectorAll('*');
      for (var k = 0; k < els.length; k++) {
        var el = els[k];
        if (el.childElementCount) continue;
        var t = (el.textContent || '').trim();
        if (!t) continue;
        if (STONE_NAMES.indexOf(t.toUpperCase()) !== -1 ||
            /^[^\u2022]+\u2022[^\u2022]+\u2022[^\u2022]+$/.test(t)) return c;
      }
    }
    return null;
  }

  /* --- 3. REVEAL: personalise the reveal screen --------------------------- */
  function personalise() {
    var month = chosenMonth();
    var data = STONES[month];
    var container = revealContainer();
    if (!data || !container || container.offsetParent === null) return;
    if (container.getAttribute('data-wv-done') === month) return;
    container.setAttribute('data-wv-done', month);

    var els = container.querySelectorAll('*');

    // heading stone word — the element whose whole text is a stone name
    // trio line — the element shaped "word • word • word"
    Array.prototype.forEach.call(els, function (el) {
      if (el.childElementCount) return;
      var t = (el.textContent || '').trim();
      if (!t) return;
      if (STONE_NAMES.indexOf(t.toUpperCase()) !== -1) {
        el.textContent = data.stone.toUpperCase();
      } else if (/^[^•]+•[^•]+•[^•]+$/.test(t)) {
        el.textContent = data.trio;
      }
    });

    // product photo — the decorative divider image appears twice with the same
    // src, so the product slot is the img whose src is unique (or still empty)
    var imgs = Array.prototype.slice.call(container.querySelectorAll('img'));
    var counts = {};
    imgs.forEach(function (i) { counts[i.getAttribute('src')] = (counts[i.getAttribute('src')] || 0) + 1; });
    var slot = imgs.filter(function (i) {
      return i.classList.contains('omnisend-form-empty-image') ||
             counts[i.getAttribute('src')] === 1;
    })[0];
    if (slot) {
      slot.src = CDN + data.img + '?width=600';
      slot.srcset = '';
      slot.alt = data.stone + ' Witches Knot Necklace';
      // The placeholder class carries a grey background that shows through
      // wherever the photo no longer fills the box — drop it and clear the
      // backgrounds on the image and its wrapper.
      // Hide until the photo is actually painted, otherwise the placeholder
      // frame flashes for a beat before the swap lands.
      slot.style.opacity = '0';
      slot.style.transition = 'opacity .25s ease';
      slot.addEventListener('load', function () { slot.style.opacity = '1'; }, { once: true });
      if (slot.complete && slot.naturalWidth) slot.style.opacity = '1';
      slot.classList.remove('omnisend-form-empty-image');
      slot.style.backgroundColor = 'transparent';
      var box = slot.parentElement;
      for (var i = 0; i < 3 && box; i++) {
        box.style.backgroundColor = 'transparent';
        box = box.parentElement;
      }
      slot.style.width = '100%';
      slot.style.height = 'auto';
      // The shots are portrait (1080x1350). On a narrow popup, cropping the
      // height keeps the CTA near the fold and the necklace stays in frame.
      // On desktop the container is wide, so the same crop would show only the
      // face — constrain the WIDTH there and let the whole photo show instead.
      if (window.innerWidth < 768) {
        slot.style.maxHeight = '260px';
        slot.style.objectFit = 'cover';
        slot.style.objectPosition = 'center 30%';
      } else {
        slot.style.maxWidth = '300px';
        slot.style.maxHeight = 'none';
        slot.style.objectFit = '';
        slot.style.display = 'block';
        slot.style.margin = '0 auto';
      }
    }

    // 3. the trio reads as an orphan at the very bottom, after a housekeeping
    //    line — move it directly beneath the sub-line, next to the reveal.
    // 4. the "check Promotions" line competes with the CTA at body size.
    var trio = null, promo = null, subline = null;
    Array.prototype.forEach.call(container.querySelectorAll('*'), function (el) {
      if (el.childElementCount) return;
      var t = (el.textContent || '').trim();
      if (!t) return;
      if (/^[^•]+•[^•]+•[^•]+$/.test(t)) trio = el;
      else if (/promotions/i.test(t)) promo = el;
      else if (/witches knot pendant/i.test(t)) subline = el;
    });
    if (trio && subline) {
      var trioHost = trio.closest('[class*="-text-"]') || trio;
      var subHost = subline.closest('[class*="-text-"]') || subline;
      if (trioHost.parentElement && subHost.parentElement &&
          trioHost.previousElementSibling !== subHost) {
        subHost.parentElement.insertBefore(trioHost, subHost.nextSibling);
      }
    }
    if (promo && promo.style.fontSize !== '11px') {
      promo.style.fontSize = '11px';
      promo.style.opacity = '0.75';
    }

    // CTA → collection of items that actually qualify
    // Only hijack the CTA on the Success screen. When the reveal is a real
    // step its button is a submit (it saves the phone number), so intercepting
    // the click there would silently drop the SMS signup.
    var isSuccess = /success-sections-container/.test(
      typeof container.className === 'string' ? container.className : ''
    );
    var cta = container.querySelector('button, a');
    if (cta && isSuccess) {
      cta.addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopImmediatePropagation();
        window.location.href = QUALIFYING;
      }, true);
    }
  }

  /* Re-entrancy guard. tick() writes to the DOM and is itself driven by a
     MutationObserver, so without this any non-idempotent write becomes an
     infinite loop that locks up the tab. */
  var busy = false;
  function tick() {
    if (busy) return;
    busy = true;
    try { labelText(); mirror(); personalise(); }
    catch (err) { /* never let the popup break the storefront */ }
    finally { setTimeout(function () { busy = false; }, 0); }
  }

  document.addEventListener('click', guard, true);
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'custom_birthMonth') mirror();
  }, true);

  // Omnisend injects and re-renders the popup well after page load
  /* --- 5. Do not re-ask people who are already in the funnel ------------------
     Arriving from the gift email should not raise the signup popup. Omnisend's own
     "exclude visitors from email" rule cannot help here: the CTA goes through
     /cart/add -> /discount/CODE -> collection, and Shopify's redirect strips the
     query string, so Omnisend's tracking parameters are gone by the time the page
     loads and it sees a stranger.

     The decision is taken ONCE at page load. It must not be reactive: mirror()
     writes wvBirthMonth the moment a month tile is picked, so a live check would
     hide the form out from under someone mid-signup. */
  var wasInFunnelAtLoad = (function () {
    try {
      return !!(localStorage.getItem('wvBirthMonth') || sessionStorage.getItem('wvBirthMonth'));
    } catch (e) {
      return false;
    }
  })();

  function suppressForm() {
    if (document.getElementById('wv-suppress-forms')) return;
    var css = document.createElement('style');
    css.id = 'wv-suppress-forms';
    css.textContent = '#omnisend-forms-container{display:none !important;}';
    document.head.appendChild(css);
  }

  function maybeSuppress() {
    if (wasInFunnelAtLoad) { suppressForm(); return; }
    // Carrying the gift code is the other proof they came from the email.
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var codes = (cart && cart.discount_codes) || [];
        for (var i = 0; i < codes.length; i++) {
          if (codes[i] && codes[i].code === 'BIRTHSTONEGIFT') { suppressForm(); return; }
        }
      })
      .catch(function () {});
  }

  function observe() {
    var r = root();
    if (!r) return setTimeout(observe, 500);
    new MutationObserver(tick).observe(r, { childList: true, subtree: true, attributes: true });
    tick();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { maybeSuppress(); observe(); });
  } else {
    maybeSuppress();
    observe();
  }
})();
